module.exports = __webpack_public_path__ + "img/logo-header.144f1da.svg";